<template>
  <el-dialog
    v-model="value"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
  <div slot="title">
    {{title}}
    <slot name="title"></slot>
  </div>
    <slot></slot>
    <div slot="footer">
      <slot name="footer">
        <el-button @click="onCancel" size="mini">取 消</el-button>
        <el-button type="primary" @click="onSubmit" size="mini">确 定</el-button>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onCancel() {
      this.$emit('onCancel');
    },
    onSubmit() {
      this.$emit('onSubmit').then(res => {
        console.log(res);
      });
    },
  },
};
</script>
